"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Configurator", {
  enumerable: true,
  get: function get() {
    return _configurator.default;
  }
});

var _configurator = _interopRequireDefault(require("./components/configurator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }